const BASE_ENDPOINT = "/api/car";

const endpointAlreadyHasQueryParams = (endpoint) =>
  endpoint.split("?").length > 1;

const validateIfItsFirstQueriParam = (endpoint, queryName, queryValue) => {
  if (endpointAlreadyHasQueryParams(endpoint)) {
    return (endpoint = endpoint.concat(`&${queryName}=${queryValue}`));
  }
  return (endpoint = endpoint.concat(`?${queryName}=${queryValue}`));
};

const Api = {
  list: async ({ queries }) => {
    let endpoint = BASE_ENDPOINT;
    const {
      page,
      brand,
      year,
      business,
      sort_by,
      order,
      type,
      transmission,
      model,
      city,
      state,
      onlyRecommended,
    } = queries;

    if (business) {
      endpoint = endpoint.concat("/business/" + business);
    }

    if (page) {
      endpoint = validateIfItsFirstQueriParam(endpoint, "page", page);
    }

    if (year) {
      endpoint = validateIfItsFirstQueriParam(endpoint, "year", year);
    }

    if (brand) {
      endpoint = validateIfItsFirstQueriParam(endpoint, "brand", brand);
    }

    if (model) {
      endpoint = validateIfItsFirstQueriParam(endpoint, "model", model);
    }

    if (transmission) {
      endpoint = validateIfItsFirstQueriParam(
        endpoint,
        "transmission",
        transmission
      );
    }

    if (type) {
      endpoint = validateIfItsFirstQueriParam(endpoint, "type", type);
    }

    if (city) {
      endpoint = validateIfItsFirstQueriParam(endpoint, "city", city);
    }

    if (state) {
      endpoint = validateIfItsFirstQueriParam(endpoint, "state", state);
    }
    if (onlyRecommended) {
      endpoint = validateIfItsFirstQueriParam(
        endpoint,
        "only-recommended",
        onlyRecommended
      );
    }

    if (queries["gte-year"] && queries["lte-year"]) {
      endpoint = validateIfItsFirstQueriParam(
        endpoint,
        "gte-year",
        queries["gte-year"]
      );

      endpoint = validateIfItsFirstQueriParam(
        endpoint,
        "lte-year",
        queries["lte-year"]
      );
    }

    if (queries["gte-price"] && queries["lte-price"]) {
      endpoint = validateIfItsFirstQueriParam(
        endpoint,
        "gte-price",
        queries["gte-price"]
      );
      endpoint = validateIfItsFirstQueriParam(
        endpoint,
        "lte-price",
        queries["lte-price"]
      );
    }

    if (sort_by && order) {
      endpoint = validateIfItsFirstQueriParam(endpoint, "sort_by", sort_by);
      endpoint = validateIfItsFirstQueriParam(endpoint, "order", order);
    }

    return fetch(endpoint);
  },
  listPendings: async () => {
    return fetch("/api/inventary/pendientes");
  },
};

export default Api;
